import { render, staticRenderFns } from "./DiscountDeleteItemModal.vue?vue&type=template&id=4d09d9fa&scoped=true"
import script from "./DiscountDeleteItemModal.vue?vue&type=script&lang=js"
export * from "./DiscountDeleteItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d09d9fa",
  null
  
)

export default component.exports